import React, { useState } from 'react';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import ReportForm from '@components/lpc/Pot/MainModule/ReportPot/ReportForm/ReportForm';
import { personRoles } from '@models/PotModel/personRoles';

import css from './ReportPot.module.scss';

type ReportPotProps = {
    personRole: string;
    potRef: string;
};

const ReportPot = ({ personRole, potRef }: ReportPotProps) => {
    const { t } = useTranslateLpc(['lpc-pot']);

    const [isReportModalOpen, setIsReportModalOpen] = useState<boolean>(false);

    return (
        <>
            {personRole === personRoles.PARTICIPANT && (
                <>
                    <ReportForm
                        isVisible={isReportModalOpen}
                        onHide={() => setIsReportModalOpen(false)}
                        potRef={potRef}
                    />
                    <div className={css.report__container}>
                        <span className={css.cta} onClick={() => setIsReportModalOpen(true)}>
                            <p> {t('report.title')}</p>
                        </span>
                    </div>
                </>
            )}
        </>
    );
};

export default ReportPot;
